module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    class: _vm.$style.root
  }, [(_vm.loading) ? _c('loading') : (!_vm.error) ? [(_vm.creative) ? [_c('creative-heading', {
    attrs: {
      "creative": _vm.creative
    }
  }), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('creative-status')], 1), _c('div', {
    staticClass: "col-md-8 text-right"
  }, [(_vm.permissions.includes("activate")) ? _c('gotu-nav-button', {
    staticClass: "mb-1",
    attrs: {
      "theme": "default-cta",
      "disabled": _vm.activatingCreative,
      "loading": _vm.activatingCreative
    },
    on: {
      "click": _vm.activateCreative
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.creative.set-as-active')))]) : _vm._e(), (_vm.canMoveFromOnboarding) ? _c('trigger-notification', {
    staticClass: "ml-1 mb-1",
    attrs: {
      "kind": "creative",
      "modelKey": _vm.creative.id,
      "notification": _vm.NOTIFICATION_EVENTS.ONBOARDING_SUCCESSFUL
    },
    on: {
      "after": function($event) {
        _vm.onAfterOnboardingNotification(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.creative.successful-onboarding')))]) : _vm._e(), (_vm.canMoveFromOnboarding) ? _c('trigger-notification', {
    staticClass: "ml-1 mb-1",
    attrs: {
      "kind": "creative",
      "modelKey": _vm.creative.id,
      "notification": _vm.NOTIFICATION_EVENTS.ONBOARDING_UNSUCCESSFUL
    },
    on: {
      "after": function($event) {
        _vm.onAfterOnboardingNotification(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.creative.unsuccessful-onboarding')))]) : _vm._e(), (_vm.permissions.includes("canTriggerAdProposalReviewNotification")) ? _c('trigger-notification', {
    staticClass: "ml-1 mb-1",
    attrs: {
      "kind": "creative",
      "modelKey": _vm.creative.id,
      "notification": _vm.NOTIFICATION_EVENTS.CREATIVITY_AD_PROPOSAL_REVIEW
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.trigger-ad-review-notification')))]) : _vm._e(), (_vm.permissions.includes("canTriggerWeAreSettingYouLiveNotification")) ? _c('trigger-notification', {
    staticClass: "ml-1 mb-1",
    attrs: {
      "kind": "creative",
      "modelKey": _vm.creative.id,
      "notification": _vm.NOTIFICATION_EVENTS.CREATIVITY_WE_ARE_SETTING_YOU_LIVE
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.trigger-we-are-setting-you-live-notification')))]) : _vm._e(), (_vm.permissions.includes("canTriggerOnboardingWarningNotification")) ? _c('trigger-notification', {
    staticClass: "ml-1 mb-1",
    attrs: {
      "kind": "creative",
      "modelKey": _vm.creative.id,
      "notification": _vm.NOTIFICATION_EVENTS.ONBOARDING_WARNING
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.trigger-onboarding-warning-notification')))]) : _vm._e()], 1)]), _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "row mb-2"
  }, [_c('assignees-info')], 1), (_vm.lastBrief) ? _c('div', {
    staticClass: "row mb-2"
  }, [_c('single-comment-box', {
    attrs: {
      "comment": _vm.lastBrief.data
    }
  })], 1) : _vm._e(), (_vm.campaign) ? _c('div', {
    staticClass: "row mb-2"
  }, [_c('campaign-info', {
    attrs: {
      "showStatus": false,
      "headerCampaignOpen": true,
      "fields": _vm.campaignFields
    }
  }), (_vm.isOfferAd()) ? _c('offer-brief', {
    attrs: {
      "offer_config": _vm.getCampaignOfferConfig()
    }
  }) : _vm._e()], 1) : _vm._e(), _c('div', {
    staticClass: "row mb-2"
  }, [(_vm.customer) ? _c('customer-info', {
    attrs: {
      "model": _vm.customer,
      "headerCustomerOpen": true
    }
  }) : _vm._e()], 1)]), _c('div', {
    staticClass: "col-8"
  }, [(_vm.displayAdvBuilder()) ? _c('adv-builder') : _vm._e(), (_vm.displayPreviewUploader()) ? _c('creative-external-previews') : _vm._e()], 1), (_vm.creative) ? _c('div', {
    staticClass: "col-8 mx-auto"
  }, [(_vm.permissions.includes("addComment")) ? _c('comment', {
    ref: "comment",
    staticClass: "mt-4",
    attrs: {
      "comment": _vm.comment
    }
  }, [_c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "buttons"
    },
    slot: "buttons"
  }, [_c('gotu-nav-button', {
    attrs: {
      "theme": "default-cta",
      "disabled": _vm.addingComment,
      "loading": _vm.addingComment
    },
    on: {
      "click": _vm.updateComment
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.comment.add-comment')))])], 1)]) : _vm._e()], 1) : _vm._e(), (_vm.canViewTimeline) ? _c('div', {
    staticClass: "col-8 mx-auto"
  }, [_c('hr'), _c('timeline', {
    staticClass: "mt-4",
    attrs: {
      "items": _vm.timelineItems
    }
  })], 1) : _vm._e()])] : _vm._e()] : ([404, 403].includes(_vm.error.code)) ? _c('not-found') : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d4e38c7"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lab/creative/Creative.vue
// module id = 2015
// module chunks = 1